module.exports = __webpack_public_path__ + "static/media/no2.46d147cc.webp";